import { PerformanceMonitoringVO } from "../vo/PerformanceMonitoringVO";
import { ProfilingTrackingEvent } from "../../tracking/ProfilingTrackingEvent";
import { TrackingCache } from "../../tracking/TrackingCache";
import { TrackingEventIds } from "../../tracking/constants/TrackingEventIds";
import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("PerformanceMonitoringTrackingCommand");
export class PerformanceMonitoringTrackingCommand {

    /**
     * Call executor only for TRACK_ONLY_PERC% of all users.
     */
    private static readonly TRACK_ONLY_PERC: number = 100;

    /**
     * Flag used to allow the execution of events based on current environment.
     *
     * During the first execution this flag could be enabled:
     * - when current environment is local.
     * - when a generated random number is between the desired percentage of users.
     */
    private static ALLOW_EXECUTION: boolean = undefined;

    /**
     * call executor only for 1% of all users
     * @param vo
     */
    public performTracking(vo: PerformanceMonitoringVO, playerLevel: number): void {
        logger.debug(vo);

        if (PerformanceMonitoringTrackingCommand.ALLOW_EXECUTION === undefined) {
            PerformanceMonitoringTrackingCommand.ALLOW_EXECUTION = EnvGlobalsHandler.globals.isTest ?
                true : Math.random() * 100 <= PerformanceMonitoringTrackingCommand.TRACK_ONLY_PERC;
        }

        if (PerformanceMonitoringTrackingCommand.ALLOW_EXECUTION) {
            let profilingTrackingEvent: ProfilingTrackingEvent = (<ProfilingTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.PROFILING));

            profilingTrackingEvent.level = playerLevel;
            profilingTrackingEvent.fps = vo.averageFPS;
            profilingTrackingEvent.maxFps = vo.maxFps;
            profilingTrackingEvent.memoryUsage = (window.performance && (<any>window.performance).memory && (<any>window.performance).memory.usedJSHeapSize) || 0;
            // profilingTrackingEvent.downloadSpeed = vo.downloadRateInKBs;

            TrackingCache.getInstance().sendEvent(TrackingEventIds.PROFILING);
        }
    }
}
